import {createUseStyles} from 'react-jss'
import {Pay} from "../../redux/types"
import ListItemCard from "../ListItemCard"
import {useTranslation} from 'react-i18next'
import { formatMoney } from '../../util/money'

interface Props {
  pays: Pay[]
}

const PayList = ({pays}: Props) => {
  const styles = useStyles()
  const {t} = useTranslation(['common', 'employees']);

  const renderHeader = () => {
    return (
      <ListItemCard className={styles.listItemContainer}>
        <div className={styles.smallCellContainer}>
          <strong>{t('from', {ns: 'common'})}</strong>
        </div>
        <div className={styles.smallCellContainer}>
          <strong>{t('to', {ns: 'common'})}</strong>
        </div>
        <div className={styles.smallCellContainer}>
          <strong>{t('hourlyWage', {ns: 'employees'})}</strong>
        </div>
        <div className={styles.smallCellContainer}>
          <strong>{t('salary', {ns: 'employees'})}</strong>
        </div>
      </ListItemCard>
    )
  }

  const renderListItems = () => {
    return pays?.map((pay, index) => {
      return (
        <ListItemCard key={`pay${index}`} className={styles.listItemContainer} index={index}>
          <div className={styles.smallCellContainer}>
            {pay.startDateString}
          </div>
          <div className={styles.smallCellContainer}>
            {pay.endDateString ?? '-'}
          </div>
          <div className={styles.smallCellContainer}>
            {pay.grossHourlyWage && formatMoney(pay.grossHourlyWage)}
          </div>
          <div className={styles.smallCellContainer}>
            {pay.grossSalary && formatMoney(pay.grossSalary)}
          </div>
        </ListItemCard>
      )
    })
  }

  return (
    <div className={styles.container}>
    {renderHeader()}
    {renderListItems()}
    </div>
  )
}

export default PayList

const useStyles = createUseStyles({
  container: {
    width: '100%',
    overflowX: 'auto',
  },
  listItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'space-between'
  },
  smallCellContainer: {
    flexShrink: 0,
    width: 100
  }
})
